import * as React from 'react';

type DataChangedType = boolean | null;

type DialogConfirmationType = {
  dialogAction: () => void;
} | null;

type DialogPreActionType = {
  current: () => void;
} | null;

type executeWithDialogType = (action: () => void) => void;

type DialogContextType = {
  dataChanged: DataChangedType;
  setDataChanged: React.Dispatch<React.SetStateAction<DataChangedType>>;
  dialogConfirmation: DialogConfirmationType;
  setDialogConfirmation: React.Dispatch<
    React.SetStateAction<DialogConfirmationType>
  >;
  dialogPreAction: DialogPreActionType;
  setDialogPreAction: React.Dispatch<React.SetStateAction<DialogPreActionType>>;
  executeWithDialog: executeWithDialogType;
};

export const DialogContext = React.createContext<DialogContextType | undefined>(
  undefined
);

type DialogContextProviderProps = {
  children: React.ReactNode;
}

export const DialogContextProvider = ({ children }: DialogContextProviderProps) => {
  const [dataChanged, setDataChanged] = React.useState<DataChangedType>(false);
  const [
    dialogConfirmation,
    setDialogConfirmation,
  ] = React.useState<DialogConfirmationType>(null);
  const [
    dialogPreAction,
    setDialogPreAction,
  ] = React.useState<DialogPreActionType>(null);

  const executeWithDialog = (action: () => void) => {
    if (dataChanged) {
      setDialogConfirmation({
        dialogAction: () => {
          setDialogConfirmation(null);
          setDataChanged(false);
          action();
        },
      });
    } else {
      action();
    }
  };

  return (
    <DialogContext.Provider
      value={{
        dataChanged,
        setDataChanged,
        dialogConfirmation,
        setDialogConfirmation,
        dialogPreAction,
        setDialogPreAction,
        executeWithDialog,
      }}
    >
      {children}
    </DialogContext.Provider>
  );
};

export const useDialogContext = (): DialogContextType => {
  const context = React.useContext(DialogContext);

  if (!context) {
    throw new Error('No host context found. Please setup the DialogContext');
  }

  return context;
};
